import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Carat, RotateClockwise } from '../Icons';
import * as Styles from './styles';
export const DropdownButton = forwardRef(function DropdownButton({ active, children, ...rest }, ref) {
    const caratPosition = active ? RotateClockwise.QuarterReverse : RotateClockwise.Quarter;
    return (_jsxs(Styles.Button, { ref: ref, active: active, ...rest, children: [_jsx(Styles.Text, { children: children }), _jsx(Styles.Icon, { children: _jsx(Carat, { rotateClockwise: caratPosition, transition: '0.6s' }) })] }));
});
//# sourceMappingURL=index.js.map